import { createStyles, rem } from '@mantine/core'

export default createStyles((theme, _params, getRef) => {
  return {
    tooltip: {
      border: `${rem(1)} solid ${theme.colors.gray[2]}`,
    },
  }
})
